export class SimpleDate {
  constructor(private date: Date) {
  }

  toJSON() {
    return this.date.toISOString().slice(0, 10);
  }

  isEqual(other: SimpleDate) {
    return this.toJSON() == other.toJSON();
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/utils/simple-date.ts